import {ngAsync} from 'shared/utils/ng-@decorators';
import {unRestangularize} from 'shared/utils/data-service-utils';
import type {ActionResponse, Loan} from 'typings/portaro.be.types';

export class CancellationDataService {
    public static serviceName = 'cancellationDataService';

    public static readonly LOAN_ITEMS_ROUTE = 'loan-items';
    public static readonly LOAN_REQUESTS_ROUTE = 'loan-requests';

    /*@ngInject*/
    constructor(private Restangular: Restangular.IService) {
    }

    // TODO asi bych zmenil POST na DELETE (backend)
    //  a asi rozdelil loan-items a loan-requests na samostatne data servisy

    @ngAsync()
    @unRestangularize()
    public async cancelLoan(loan: Loan): Promise<ActionResponse> {
        return this.Restangular
            .one(CancellationDataService.LOAN_ITEMS_ROUTE, loan.id)
            .all('cancel')
            .post({loan: loan.id});
    }

    @ngAsync()
    @unRestangularize()
    public async cancelLoanRequest(loanRequest: Loan): Promise<ActionResponse> {
        return this.Restangular
            .one(CancellationDataService.LOAN_REQUESTS_ROUTE, loanRequest.loanRequestId)
            .all('cancel')
            .post({loanRequest: loanRequest.loanRequestId});
    }
}